import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Page } from "src/app/model/Page";
import { AuditTrailModel } from "src/app/model/AuditTrailModel";
import { ApplicantStatusService } from "src/app/services/Applicant-Status.service";

@Component({
  selector: "app-secure-document-verificationAllotment",
  templateUrl: "./appointmentAudit-trail.component.html",
  styleUrls: ["./document-verification.component.scss"],
})
export class AppointmentAuditTrailComponent implements OnInit {
  lotteryList: AuditTrailModel[] = [];
  loaded: boolean = false;
  isloaded: boolean = false;
  statusList: any[] = [
    { name: "PENDING", value: "PENDING" },
    { name: "POSSESION COMPLETE", value: "POSSESION_COMPLETE" },
  //  { name: "INELIGBLE FOR POL", value: "INELIGBLE_FOR_POL" },
  ];
  selectedLotteryCode: string | null = null;
  page: Page<AuditTrailModel>;
  dataSource: MatTableDataSource<AuditTrailModel> =
    new MatTableDataSource();
  // form: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  lotterysName: { [key: number]: string };
  status: { [key: number]: string };
  lotteryEventId: number;
  statusId: string;
  applicationNumber: number;
  applicantname: string;

  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "appointmentId",
    "status",
    "auditType",
    "users",
    "auditDate",
   
  ];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 100;
  pageSize = 100;
  currentPage = 0;

  constructor(
    private _snackBar: MatSnackBar,

    private route: ActivatedRoute,

    private ApplicantStatusService: ApplicantStatusService,

  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.loaded = true;
     
    });

    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem("app-secure-payment-settlement-filterText"),
        [Validators.required, Validators.minLength(1)]
      ),
      
    });
    this.filterForm.controls["filterText"].setValue(null);
  }
 


  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.page = null;
    this.dataSource = new MatTableDataSource();
    this.currentPage = 0;
    this.paginator.pageIndex = this.currentPage;
    this.paginator.length = 0;
    this.applicantname= null;
  }
  onSearch() {
    if (this.filterForm.valid) {
      this.page = null;
      this.applicationNumber = this.filterForm.value.filterText;
      this.dataSource = null;
      this.pageSize = 100;
      this.currentPage = 0;
      localStorage.setItem(
        "app-secure-payment-settlement-filterText",
        this.filterForm.value.filterText
      );

      this.onLoad();
    } else {
      this._snackBar.open(
        "Appointment Id is Required ",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }
  onLoad() {
    this.loaded = false;
    // console.log(
    //   "this.filterForm.value.filterText",
    //   this.filterForm.value.filterText
    // );

    this.ApplicantStatusService
      .fetchAuditTrail(
        
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (page: any) => {
          this.page = page;

          // console.log("page>>>>>>>>>>>>>>>>>>",page);
          

          if (page.content && page.content.length !== 0) {
            this.dataSource = new MatTableDataSource(page.content);
            this.applicantname = page.content[0]?.applicantname; // Assuming the applicant name is the same for all rows

            // console.log("application",this.applicationNumber);
            // console.log("this.dataSource",this.dataSource);
          } else {
            this._snackBar.open(
              "Please Enter Valid Appointment Id ",
              "Close",
              {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "warning-toast",
                duration: 3 * 1000,
              }
            );
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
          this.loaded = true;
          this.isloaded = true;
        },
        (error) => {
          console.log(error);
          this.loaded = false;
          this.isSearchDisabled = false;
        }
      );
  }


  pageChanged(event: PageEvent) {
    // console.log({ event });
    // console.log(event.pageSize);
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  
}
